import { useQuery } from '@tanstack/react-query'
import { useDI } from '@/di/DIContext'
import type { AgentId } from '@/domain/shared/Brand'

export function useUserProfile() {
  const { accountService, sessionService } = useDI()
  const agentId = sessionService.getAgentId()

  const {
    data: userProfile,
    isLoading: isUserProfileLoading,
    isError: isUserProfileError,
    isSuccess: isUserProfileSuccess,
    isFetching: isUserProfileFetching,
    error: userProfileError,
  } = useQuery({
    queryKey: ['userProfile', agentId],
    queryFn: () => accountService.getProfile(agentId as AgentId),
    enabled: !!agentId,
    gcTime: 0,
    retry: false,
  })

  return {
    userProfile,
    isUserProfileLoading,
    isUserProfileError,
    isUserProfileSuccess,
    isUserProfileFetching,
    userProfileError,
  }
}
